// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
export const centeredFlex = {
    display: 'flex',
    alignItems: 'center'
};
export const leftToRight = {
    flexDirection: 'row'
};
export const rightToLeft = {
    flexDirection: 'row-reverse'
};
export const equiDistant = {
    justifyContent: 'space-between'
};
//# sourceMappingURL=layout.js.map